import { useSyncExternalStore } from "react";
import type { CursorInputContextValue } from "@/components/layout/cursor-input-context";

let currentValue: CursorInputContextValue | null = null;
const listeners = new Set<() => void>();

export function publishCursorInputContextBridge(
  value: CursorInputContextValue | null,
) {
  if (currentValue === value) return;
  currentValue = value;
  listeners.forEach((listener) => listener());
}

/**
 * Returns the active same-window input controller when compact desktop
 * chrome sits outside the provider subtree.
 */
export function useCursorInputContextBridge(): CursorInputContextValue | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => currentValue,
    () => null,
  );
}
